import { observer } from 'mobx-react';
import React, { Fragment } from 'react';
import { useHistory, useRouteMatch, NavLink } from 'react-router-dom';
import './formulaList.scss';
import stores from 'cd-eft/models/Stores';

const FormulaListComponent = () => {
  const { path } = useRouteMatch();
  return (
    <Fragment>
      <div className="formulas-intro-banner">
        <h1>Formulas</h1>
        <p>
        The NETS framework includes functionality from prior versions of NRCS Hydraulic Formulas and EFT Utilities, 
        which bundle large numbers of calculation utilities. Each of those tools includes its own Help file. Also, 
        more Formula tools are intended to be included in future NETS releases, as new tools are defined and developed. 
        Therefore, this Formula page does not try to cover every individual formula; see the formula-specific help files 
        for the details of each tool.
        </p>
      </div>
      <div className="full-formula-list">
        <div className="column">
          <h2>Hydraulic Structures</h2>
          <ul className="list-style">
            <li>
              <NavLink to={`${path}/box-drop-inlet`}>Box Drop Inlet</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/dry-hydrant`}>Dry Hydrant</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/hooded-inlet`}>Hooded Inlet</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/water-control`}>In-line Water Control Structure</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/parabolic-channel`}>Parabolic Channel Section</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/pipe-drop`}>Pipe Drop Structure</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/plunge-pool`}>Plunge Pool</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/rectangular-riser-drop`}>Rectangular Riser Drop</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/straight-drop-inlet`}>Straight Drop Inlet</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/trapezoidal-channel`}>Trapezoidal Channel Section</NavLink>
            </li>
          </ul>
        </div>
        <div className="column">
          <h2>Miscellaneous: Hydraulic</h2>
          <ul className="list-style">
            <li>
              <NavLink to={`${path}/circular-section`}>Gravity Flow in a Circular Section</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/orifice-flow`}>Orifice Flow</NavLink>
            </li>
            {/* <li>
              <NavLink to={`${path}/pipe-flow-formula`}>Pipe Flow Formula</NavLink>
            </li> */}
            <li>
              <NavLink to={`${path}/pressure-flow-in-pipe`}>Pressure Flow in Pipe</NavLink>
            </li>
          </ul>
          <div className="list-drainage-column">
            <h2>Weir Flow</h2>
            <ul className="list-style">
              <li>
                <NavLink to={`${path}/vnotch-weir`}>V-Notch Weir</NavLink>
              </li>
              <li>
                <NavLink to={`${path}/weir-flow`}>Weir Flow</NavLink>
              </li>
            </ul>
          </div>
        </div>
        {stores.AppStore.userProfileStore.applicationFlags.enableformulas1 ? <div className="column">
          <h2>Plane Forms</h2>
          <ul className="list-style">
            <li>
              <NavLink to={`${path}/circle`}>Circle</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/equilateral-triangle`}>Equilateral Triangle</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/oblique-triangle`}>Oblique Triangle</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/parabola`}>Parabola</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/parallelogram`}>Parallelogram</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/rectangular`}>Rectangular</NavLink>
            </li>
          </ul>
        </div> : null}
        {stores.AppStore.userProfileStore.applicationFlags.enableformulas1 ? <div className="column">
          <h2>Solid Forms</h2>
          <ul className="list-style">
            <li>
              <NavLink to={`${path}/cube`}>Cube</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/frustum-cone`}>Frustum of a Cone</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/frustum-pyramid`}>Frustum of a Pyramid</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/prismatoid`}>Prismatoid</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/rectangular-parallelepiped`}>Rectangular Parallelepiped</NavLink>
            </li>
            <li>
              <NavLink to={`${path}/sphere`}>Sphere</NavLink>
            </li>
          </ul>
          <div className="list-drainage-column">
            <h2>Drainage</h2>
            <ul className="list-style">
              <li>
                <NavLink to={`${path}/pump-drainage`}>Pump Drainage</NavLink>
              </li>
              <li>
                <NavLink to={`${path}/subsurface-drainage`}>Subsurface Drainage</NavLink>
              </li>
              <li>
                <NavLink to={`${path}/surface-inlet`}>Surface Inlet</NavLink>
              </li>
            </ul>
          </div>
        </div> : null}
      </div>
    </Fragment>
  );
};

export const FormulaList = observer(FormulaListComponent);
